export default __webpack_public_path__ + "static/media/hands.e648dfdd.png";